import React, { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const close = () => setMenuOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [menuOpen]);

  const navLinks = [
    { label: 'How It Works', href: '/#how-it-works' },
    { label: 'Blog', href: '/blog' },
    { label: 'FAQ', href: '/#faq' },
  ];

  return (
    <>
      <header style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        height: 60,
        display: 'flex',
        alignItems: 'center',
        padding: '0 12px',
        background: scrolled ? 'rgba(255,255,255,0.92)' : '#ffffff',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        borderBottom: `1px solid ${scrolled ? 'rgba(0,0,0,0.06)' : '#f1f5f9'}`,
        transition: 'background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
        boxShadow: scrolled ? '0 1px 12px rgba(0,0,0,0.05)' : 'none',
      }}>
        <div style={{ maxWidth: 1120, width: '100%', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

          <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', flexShrink: 0 }}>
            <img src="/logo-icon-navy.svg" alt="" style={{ height: 42, width: 42, borderRadius: 11, flexShrink: 0 }} />
            <span className="header-brand-text" style={{ fontSize: 18, fontWeight: 800, color: '#0f172a', letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}>Solar Cost <span style={{ color: '#16a34a' }}>Predictor</span></span>
          </a>

          <nav style={{ display: 'flex', alignItems: 'center', gap: 4 }} className="header-desktop-nav">
            {navLinks.map(item => (
              <a
                key={item.href}
                href={item.href}
                style={{ fontSize: 14, fontWeight: 500, color: '#475569', padding: '6px 12px', borderRadius: 8, transition: 'color 0.12s, background 0.12s', textDecoration: 'none', whiteSpace: 'nowrap' }}
                onMouseEnter={e => { e.currentTarget.style.color = '#0a0a0a'; e.currentTarget.style.background = '#f8fafc'; }}
                onMouseLeave={e => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.background = 'transparent'; }}
              >
                {item.label}
              </a>
            ))}
            <a
              href="/partner-with-us"
              style={{ fontSize: 14, fontWeight: 700, color: '#1b4d3e', padding: '6px 12px', borderRadius: 8, transition: 'color 0.12s, background 0.12s', textDecoration: 'none', whiteSpace: 'nowrap' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#eaf3ee'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
            >
              Partner With Us
            </a>
            <a
              href="/for-installers"
              style={{ marginLeft: 8, fontSize: 13, fontWeight: 600, color: '#1b4d3e', padding: '7px 16px', borderRadius: 9, border: '1.5px solid #1b4d3e', background: 'transparent', textDecoration: 'none', transition: 'background 0.12s, color 0.12s', letterSpacing: '-0.01em', whiteSpace: 'nowrap' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#1b4d3e'; e.currentTarget.style.color = '#ffffff'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#1b4d3e'; }}
            >
              Get Solar Estimator
            </a>
          </nav>

          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }} className="header-mobile-nav">
            <a
              href="/for-installers"
              style={{ fontSize: 11, fontWeight: 600, color: '#1b4d3e', padding: '5px 10px', borderRadius: 8, border: '1.5px solid #1b4d3e', background: 'transparent', textDecoration: 'none', whiteSpace: 'nowrap', letterSpacing: '-0.01em' }}
            >
              Get Solar Estimator
            </a>
            <button
              onClick={e => { e.stopPropagation(); setMenuOpen(o => !o); }}
              aria-label="Toggle menu"
              style={{ width: 38, height: 38, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, background: 'none', border: '1.5px solid #e2e8f0', borderRadius: 9, cursor: 'pointer', padding: 0, flexShrink: 0 }}
            >
              <span style={{ display: 'block', width: 16, height: 1.5, background: '#334155', borderRadius: 2, transition: 'transform 0.2s', transform: menuOpen ? 'translateY(6.5px) rotate(45deg)' : 'none' }} />
              <span style={{ display: 'block', width: 16, height: 1.5, background: '#334155', borderRadius: 2, opacity: menuOpen ? 0 : 1, transition: 'opacity 0.15s' }} />
              <span style={{ display: 'block', width: 16, height: 1.5, background: '#334155', borderRadius: 2, transition: 'transform 0.2s', transform: menuOpen ? 'translateY(-6.5px) rotate(-45deg)' : 'none' }} />
            </button>
          </div>
        </div>
      </header>

      {menuOpen && (
        <div
          onClick={e => e.stopPropagation()}
          style={{ position: 'fixed', top: 60, left: 0, right: 0, zIndex: 99, background: '#ffffff', borderBottom: '1px solid #f1f5f9', boxShadow: '0 8px 24px rgba(0,0,0,0.08)', padding: '8px 24px 16px' }}
          className="header-mobile-menu"
        >
          {navLinks.map(item => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              style={{ display: 'block', fontSize: 15, fontWeight: 500, color: '#111827', padding: '12px 0', borderBottom: '1px solid #f8fafc', textDecoration: 'none' }}
            >
              {item.label}
            </a>
          ))}
          <a
            href="/partner-with-us"
            onClick={() => setMenuOpen(false)}
            style={{ display: 'block', fontSize: 15, fontWeight: 700, color: '#1b4d3e', padding: '12px 0', borderBottom: '1px solid #f8fafc', textDecoration: 'none' }}
          >
            Partner With Us
          </a>
        </div>
      )}

      <style>{`
        @media (min-width: 640px) {
          .header-desktop-nav { display: flex !important; }
          .header-mobile-nav  { display: none  !important; }
          .header-mobile-menu { display: none  !important; }
        }
        @media (max-width: 639px) {
          .header-desktop-nav { display: none  !important; }
          .header-mobile-nav  { display: flex !important; }
        }
        @media (max-width: 460px) {
          .header-brand-text { display: none !important; }
        }
      `}</style>
    </>
  );
}
